import React from 'react';
import { withRouter } from 'react-router-dom';

// eslint-disable-next-line react/prop-types
const RouteChangeTracker = () => <div />;

export default withRouter(RouteChangeTracker);
